import './tray-footer.component.scss'
import { ContentStreamComponent } from '../../../content-stream/content-stream.component';

/**
 * @ngdoc directive
 * @name mwContentDocumentTrayFooter
 * @module mw.components.contentDocuments
 *
 * @param {expression} [on-close] - Function to be called when the 'close' button is clicked
 *
 * @description
 * `<mw-content-document-tray-footer`> is a component used to display optional label and action button at the bottom of a tray.
 *
 * @usage
 * <hljs hljs-language="html">
 *     <mw-content-document-tray-footer on-close="$ctrl.someTrayCloseHandler()">
 *          <span>Some Label</span>
 *          <md-button class="mw-button">Some Action</md-button>
 *     </mw-content-document-tray-footer>
 * </hljs>
 */

const template = `
    <div class="mw-content-document-tray-footer" layout="row">
        <ng-transclude class="mw-content-document-tray-footer__label" flex="noshrink" ng-transclude-slot="mwContentDocumentTrayFooterLabel"></ng-transclude>
        <div flex="100"></div>
        <ng-transclude ng-transclude-slot="mwContentDocumentTrayFooterShowMore"></ng-transclude>

        <mw-icon-button
            svg-icon="navigation:ic_close_24px"
            hover="true"
            size="small"
            ng-click="$ctrl.handleOnClose($event)"
            flex="noshrink"
            ></mw-icon-button>
    </div>
`;

export class TrayFooterComponent {
    static config = {
        selector: 'mwContentDocumentTrayFooter',
        bindings: {
            onClose: '&',
        },
        require: {
            contentStreamCmp: '?^^mwContentStream'
        },
        transclude: {
            'mwContentDocumentTrayFooterLabel': '?span',
            'mwContentDocumentTrayFooterShowMore': '?mdButton'
        },
        controller: TrayFooterComponent,
        template
    }

    private onClose;
    private contentStreamCmp: ContentStreamComponent;

    handleOnClose($event) {
        if (this.contentStreamCmp && $event) {
            this.contentStreamCmp.scrollDocumentIntoView($event.srcElement);
        }

        if (this.onClose) {
            this.onClose({$event: $event});
        }
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/content-documents/shared/tray-footer/tray-footer.component.ts